module.exports = __webpack_public_path__ + "static/media/facebook_post3.f2569e33.png";